import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { AppStore } from '@store/app.store';
import { selectIsAuthenticated } from '@store/store-auth-user/auth-user.selectors';

export const authGuard: CanActivateFn = (_route, state) => {
    const store = inject(Store<AppStore>);
    const router = inject(Router);

    return store.select(selectIsAuthenticated).pipe(
        map(isAuthenticated => {
            if (isAuthenticated) {
                return true;
            } else {
                router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }
        }),
    );
};
